import { inject, Injectable } from '@angular/core';
import { useCompanyAccessStatus } from 'app/core/helpers/company-access.helper';
import { EmptyPaginatedResponse } from 'app/core/http/base-paginated-response';
import { DeviceFailuresApi } from 'app/modules/admin/overview/company-devices-failures-widget/device-failures.api';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DeviceFailuresService {
    private _deviceFailuresApi = inject(DeviceFailuresApi);

    readonly companyStatus = useCompanyAccessStatus();

    /**
     * Get device failures.
     */
    getCompanyDevicesFailures(
        companyId?: number,
        deviceId?: number,
        failureTypeId?: number,
        from?: string,
        to?: string,
        page: number = 1,
        size: number = 5,
    ) {

         if (this.companyStatus().isRestricted) {
            return of(EmptyPaginatedResponse);
        }
        const paramsObj = {
            company: companyId,
            machine: deviceId,
            type: failureTypeId,
            from: from,
            to: to,
            page: page,
            limit: size
        };

        return this._deviceFailuresApi.getPaginated(paramsObj);
    }

    /**
     * Export device accesses as an Excel file, with filters.
     */
    /**
     *
     * @param companyId
     * @param machineId
     * @param failureTypeId
     * @param from
     * @param to
     * @param page
     * @param size
     */
    exportFailuresAsExcel(
        companyId?: number,
        machineId?: number,
        failureTypeId?: number,
        from?: string,
        to?: string,
        page?: number,
        size?: number,
    ) {
        const paramsObj = {
            machine: machineId,
            company: companyId,
            type: failureTypeId,
            from: from,
            to: to,
            page: page,
            limit: size
        };

        return this._deviceFailuresApi.exportAsExcel(paramsObj);
    }
}
